import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Registry from './views/Registry.vue'
import Detection from './views/Detection.vue'
import Evaluation from './views/Evaluation.vue'
import Rectification from './views/Rectification.vue'
import Archive from './views/Archive.vue'
import Reports from './views/Reports.vue'
import Audit from './views/Audit.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', component: Login, meta: { title: '登录', public: true } },
    { path: '/', component: Dashboard, meta: { title: '总览' } },
    { path: '/registry', component: Registry, meta: { title: '处理单元' } },
    { path: '/detection', component: Detection, meta: { title: '检测记录' } },
    { path: '/evaluation', component: Evaluation, meta: { title: '达标评估' } },
    { path: '/rectification', component: Rectification, meta: { title: '整改处置' } },
    { path: '/archive', component: Archive, meta: { title: '资料归档' } },
    { path: '/reports', component: Reports, meta: { title: '报表分析' } },
    { path: '/audit', component: Audit, meta: { title: '权限审计' } }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.public || window.localStorage.getItem('tailwater_token')) next()
  else next('/login')
})

export default router
